import { Link } from 'react-router-dom';
import { TruckIcon } from '../common/icons.jsx';

const STATUS_CONFIG = {
  draft: { label: 'Brouillon', bg: 'bg-gray-100', text: 'text-gray-700', header: 'bg-gray-50' },
  active: { label: 'Active', bg: 'bg-blue-50', text: 'text-[var(--color-accent)]', header: 'bg-blue-50' },
  completed: { label: 'Terminée', bg: 'bg-emerald-50', text: 'text-emerald-700', header: 'bg-emerald-50' },
};

/**
 * Single plan card with colored header, progress bar, and driver badge.
 * @param {{ plan: object }} props
 */
export default function PlanCard({ plan }) {
  const cfg = STATUS_CONFIG[plan.status] || STATUS_CONFIG.draft;
  const progress = plan.stop_count > 0
    ? Math.round((plan.delivered_count / plan.stop_count) * 100) : 0;
  const driverInitials = (plan.driver_name || '?')
    .split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();

  return (
    <Link
      to={`/plans/${plan.id}`}
      className="block bg-white rounded-xl shadow-[var(--shadow-sm)] hover:shadow-[var(--shadow-md)] overflow-hidden"
    >
      <div className={`px-4 py-2 ${cfg.header} flex justify-between items-center`}>
        <span className="text-sm font-semibold text-[var(--color-primary)]">{formatDateFr(plan.date)}</span>
        <span className={`text-xs px-2.5 py-1 rounded-full font-medium ${cfg.bg} ${cfg.text}`}>
          {cfg.label}
        </span>
      </div>
      <div className="px-4 py-3">
        <div className="flex justify-between items-center mb-2">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-full bg-[var(--color-accent)] text-white flex items-center justify-center text-[10px] font-bold">
              {driverInitials}
            </div>
            <span className="text-sm font-medium text-[var(--color-primary)]">{plan.driver_name || 'Non assigné'}</span>
          </div>
          <div className="flex items-center gap-1.5 text-xs text-[var(--color-neutral)]">
            <TruckIcon size={14} />
            <span>{plan.stop_count} arrêts</span>
            <span className="mx-1">-</span>
            <span>{plan.total_units} unités</span>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex-1 h-2 bg-gray-100 rounded-full overflow-hidden">
            <div
              className="h-full bg-[var(--color-success)] rounded-full animate-progress"
              style={{ width: `${progress}%` }}
            />
          </div>
          <span className="text-xs font-semibold text-[var(--color-neutral)] w-10 text-right">{progress}%</span>
        </div>
      </div>
    </Link>
  );
}

/**
 * Format a date string to readable French format.
 * @param {string | undefined} dateStr
 * @returns {string}
 */
function formatDateFr(dateStr) {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleDateString('fr-FR', {
    weekday: 'long', day: 'numeric', month: 'long',
  });
}
